import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-content-between" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "h3" }, "Disconnect your wallet?", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "my-s4 text-gray" }, "Pending transactions may be undone", -1)
const _hoisted_4 = { class: "mt-s6 flex justify-content-between dialog-footer-two-btn" }

import ControlIcon from '@/components/ControlIcon.vue';


export default /*#__PURE__*/_defineComponent({
  emits: ["cancel", "confirm"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'cancel'): void;
  (e: 'confirm'): void;
}), expose: any, slots: any, attrs: any }) {



return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(ControlIcon, {
        class: "p-dialog-header-close",
        name: "close",
        size: "20",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('cancel')))
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        class: "button-base",
        label: "Cancel",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('cancel')))
      }),
      _createVNode(_component_Button, {
        class: "button-primary",
        label: "Disconnect",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('confirm')))
      })
    ])
  ], 64))
}
}

})